import React from 'react';
import './styles.scoped.css';

const Button = ({
  text = '',
  children,
  icon,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  onPress,
  onClick,
  className = '',
  style = {},
  ...rest
}) => (
  <button
    type="button"
    style={{ ...style, padding: icon && !text && !children ? 0 : undefined }}
    className={['button', variant, size !== 'md' ? size : '', fullWidth ? 'fullWidth' : '', disabled ? 'disabled' : '', className]
      .filter(Boolean)
      .join(' ')}
    onClick={onPress || onClick}
    disabled={disabled}
    {...rest}>
    {icon && <span className="icon">{icon}</span>}
    {text && <span>{text}</span>}
    {!text && children}
  </button>
);

export default Button;
